import { ComponentProps, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { FormValues } from '@sbv-clients/ui-forms';
import { Box, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { schema } from './scheme';
import SignInForm from './sign-in-form';

export interface SharedSignInPageProps {
  portal: 'facility' | 'admin';
  onSubmit: (formValues: FormValues<typeof schema>) => Awaited<void>;
  children?: ReactNode;
}

export const SharedSignInPage = ({
  onSubmit,
  portal,
  children,
}: SharedSignInPageProps) => {
  return (
    <SharedAuthLayout>
      <Box mb={6} textAlign="center">
        <Typography variant="h1" fontWeight={700} mb={2}>
          Welcome back
        </Typography>
        <Typography color="text.secondary" mb={2}>
          Sign in to your account to continue
        </Typography>
      </Box>
      <SignInForm portal={portal} onSubmit={onSubmit} />
      {children}
      {portal === 'facility' && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          columnGap={1}
          mt={6}
        >
          <Typography color="text.secondary">Don’t have an account?</Typography>
          <Link to="/auth/verify-phone">
            <Typography color="primary" fontWeight="bold">
              Sign up
            </Typography>
          </Link>
        </Box>
      )}
    </SharedAuthLayout>
  );
};
